import { createRoute, Outlet } from "@tanstack/react-router";
import { ContactsPage } from "pages/app/ContactsPage";

import { rootRoute } from "../rootRoute";

export const contactsLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contacts",
  staticData: { pageName: "", breadcrumbLabel: "Contacts" },
  component: Outlet,
});

export const contactsIndexRoute = createRoute({
  getParentRoute: () => contactsLayoutRoute,
  path: "/",
  staticData: { pageName: "Contacts" },
  component: ContactsPage,
});

export const contactsRouteTree = contactsLayoutRoute.addChildren([contactsIndexRoute]);
